export default __webpack_public_path__ + "static/media/information--highway-reference-location--g2.8a376ffd.png";